import { render, staticRenderFns } from "./GeneClassSymbolDetailRegistrationForm.vue?vue&type=template&id=04a26385&scoped=true"
import script from "./GeneClassSymbolDetailRegistrationForm.vue?vue&type=script&lang=js"
export * from "./GeneClassSymbolDetailRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./GeneClassSymbolDetailRegistrationForm.vue?vue&type=style&index=0&id=04a26385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a26385",
  null
  
)

export default component.exports